import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getVariantsList = createApi("GetVariantsListSlice", 'GET');

const GetVariantsListSlice = createSlice({
  name: 'GetVariantsListSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVariantsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVariantsList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getVariantsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetVariantsListSlice.reducer;